import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import 'survey-core/defaultV2.min.css'
// import * as serviceWorkerRegistration from './serviceWorker'

// 根據某些條件決定是否引入全局樣式
// if (
//   !window.location.pathname.includes('/p240430105824') ||
//   !window.location.pathname.includes('/P240430105824')
// ) {
//   import('./index.css')
// }
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// serviceWorkerRegistration.register()
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', function () {
//     navigator.serviceWorker.register('/service-worker.js', { scope: '/' }).then(
//       function (registration) {
//         console.log('Service Worker OK', registration.scope)
//       },
//       function (err) {
//         console.log('Service Worker failed', err)
//       }
//     )
//   })
// }

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister().then((success) => {
      if (success) {
        console.log('Service Worker: Unregister successful')
      } else {
        console.log('Service Worker: Unregister failed')
      }
    })
  })
}
